import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import EventTimesheetTab from "../../../../../components/Events/Event/timesheet/EventTimesheetTab";
import { ExportTimesheetModal } from "../../../../../components/Events/Event/timesheet/modals";
import { TIMESHEET_APPLICANT_STATUSES } from "../../../../../components/Events/Event/timesheet/constants";
import { exportExcelRequest, exportExcelResponse } from "../../../../../store/TimeSheet/actions";
import { eventTypes } from "../../../../../utils/Constants";
import useAdminEventTimesheet from "./useAdminEventTimesheet";

import "./TimesheetTab.scss";

const TimesheetTab = () => {
  const dispatch = useDispatch();
  const linkRef = useRef(null);
  const event = useSelector((state) => state.events.event);
  const excelLink = useSelector((state) => state.timesheet.excelLink);
  const adminTimesheet = useAdminEventTimesheet(event);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  useEffect(() => {
    if (!excelLink) {
      return;
    }

    linkRef.current?.click();
    dispatch(exportExcelResponse(null));
  }, [dispatch, excelLink]);

  const integration = useMemo(
    () => ({
      ...adminTimesheet,
      onExportAll: () => setIsExportModalOpen(true),
    }),
    [adminTimesheet],
  );

  const handleExportConfirm = (columns, selectedFields) => {
    dispatch(
      exportExcelRequest({
        event_id: event?.id,
        page: -1,
        is_removed:
          adminTimesheet.filters.status?.id ===
          TIMESHEET_APPLICANT_STATUSES.removed,
        _selectedColumns: selectedFields.map(({ name, label }) => ({
          value: name,
          label,
        })),
        _eventName: event?.name,
        _eventType: eventTypes.daily,
        ...columns,
      }),
    );

    setIsExportModalOpen(false);
  };

  return (
    <>
      <a ref={linkRef} href={excelLink || undefined} className="d-none">
        download
      </a>
      <EventTimesheetTab
        event={event}
        className="admin-event-timesheet-tab"
        integration={integration}
      />
      <ExportTimesheetModal
        open={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        onConfirm={handleExportConfirm}
      />
    </>
  );
};

export default TimesheetTab;
